import { ConfigProvider } from 'antd';
import { Provider as MobxProvider } from 'mobx-react';
import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import { Router, Switch, Route, useLocation } from 'react-router-dom';
import 'antd/dist/antd.less';
import './assets/css/global.module.scss';
import '@tencent/tds-ui/assets/tds-ui.min.css';
import { getHistory } from '@/infrastructure/history';
import { MainApp } from '@/presentation';
import { SdkAppleReviewAnnouncementModal } from '@/presentation/components/sdk-apple-review-announcement-modal';
import zhCN from '@/presentation/config/zh_CN';
import { AuthProvider } from '@/presentation/hooks';
import { GlobalConfigProvider } from '@/presentation/hooks/global';
import RightlyHomepage from '@/presentation/pages/compliance/homepage';
import ExternalLink from '@/presentation/pages/external-link';
import { MainPage } from '@/presentation/pages/main';
import { TDSMainPage } from '@/presentation/pages/main-pro/tds-index';
import { AlertNotice } from '@/presentation/pages/setting/alert-notice';
import { stores, StoresContext } from '@/presentation/store';
import { AppConfigProvider, MultiApp } from './config/context';
import ComplianceBulletin from './presentation/pages/compliance-buttetin';
import QQConnectCallback from './presentation/pages/qqconnect';
import Consult from './presentation/pages/resource-pack/consult';
import './assets/css/index.css';
import '@arco-design/web-react/dist/css/arco.css';

const AuthProviderWithLocation: FC = (props) => {
  const location = useLocation();

  return <AuthProvider location={location}>{props.children}</AuthProvider>;
};

const currentApp = process.env.APP_VERSION as MultiApp;
// const currentApp = 'pro' as MultiApp;

const App = () => (
  <AppConfigProvider app={currentApp}>
    <MobxProvider {...stores}>
      <ConfigProvider locale={zhCN}>
        <GlobalConfigProvider>
          <StoresContext.Provider value={stores}>
            <Router history={getHistory()}>
          <SdkAppleReviewAnnouncementModal />
              <AuthProviderWithLocation>
                <Switch>
                  <Route exact path={'/'} component={MainPage} />
                  <Route path={'/index/tds-main'} component={TDSMainPage}/>
                  <Route path={'/consult'} component={Consult}/>
                  <Route path={'/alert-notice'} component={AlertNotice}/>
                  <Route path={'/compliance-buttetin'} component={ComplianceBulletin}/>
                  <Route path={'/index/main'} component={MainPage}/>
                  <Route path={'/index/rightly'} component={RightlyHomepage}/>
                  <Route path={'/qqconnect/callback'} component={QQConnectCallback}/>
                  <Route path={'/link'} component={ExternalLink}/>
                  <Route component={MainApp}/>
                </Switch>
              </AuthProviderWithLocation>
            </Router>
          </StoresContext.Provider>
        </GlobalConfigProvider>
      </ConfigProvider>
    </MobxProvider>
  </AppConfigProvider>
);

ReactDOM.render(<App />, document.getElementById('app'));
